import { useQuery } from 'react-query';
import '../../constants/authorizedUsers.js';
import '../../constants/bidStatus.js';
import '../../constants/bulkLoadCardStatus.js';
import '../../constants/misc.js';
import '../../constants/event-names.js';
import '../../constants/eventsMapObj.js';
import '../../constants/Faq.js';
import '../../constants/languages.js';
import '../../constants/loadStatus.js';
import '../../constants/lorryStatus.js';
import '../../constants/lorryTypes.js';
import '../../constants/mostSearchedLinks.js';
import '../../constants/Pages.js';
import 'react';
import '../../constants/serviceTypeId.js';
import '../../constants/StateList.js';
import '../../constants/bidUpdateType.js';
import '../../constants/userAction.js';
import '../../constants/api.js';
import '../../constants/link.js';
import '../../constants/market.js';
import '../../constants/payment.js';
import '../../constants/admin/screenId.js';
import API from '../const.js';
import 'bowser';
import '../../_virtual/_tslib.js';
import '../../components/toast/toast.js';
import '../auth.service.js';
import { getAuthIdParam } from '../../methods/getAuthIdParam.js';
import 'react-cookie';
import '../../methods/formatDate.js';
import '../../methods/getTransporterFigure.js';
import '../../methods/getDownloadsFigure.js';
import 'lodash.isequal';
import '../../methods/getPageLoadSourceUTMParam.js';
import 'crypto-js';
import { getAuthHeader } from '../utils/getAuthHeader.js';
import { QueryNames } from './queryNames.js';

function useGetRoutesByCompanyId({ companyId, options }) {
    const { data, isFetching } = useQuery([QueryNames.routesByCompanyId, companyId], () => fetch(`${API.ROUTES_BY_COMPANY_ID}${getAuthIdParam()}&c_i=${companyId}`, {
        headers: Object.assign({}, getAuthHeader())
    }).then((res) => res.json()), Object.assign({}, options));
    return { data: data === null || data === void 0 ? void 0 : data.data, isFetching };
}

export { useGetRoutesByCompanyId };
//# sourceMappingURL=useRoutesService.js.map
